import { createRequest } from '../../../services/request';

export const SET_DEAD_END_FOR_CLAIM_GROUP = createRequest(
  '@@SAV/CLAIMS/SET_DEAD_END_FOR_CLAIM',
);
